import { render, staticRenderFns } from "./StudentExamineeidentity.vue?vue&type=template&id=eb841f56&scoped=true"
import script from "./StudentExamineeidentity.vue?vue&type=script&lang=js"
export * from "./StudentExamineeidentity.vue?vue&type=script&lang=js"
import style0 from "./StudentExamineeidentity.vue?vue&type=style&index=0&id=eb841f56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb841f56",
  null
  
)

export default component.exports